import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Notification {
  id?: number;
  status: string | null;
  message: string | null;
  isViewed: boolean;
}

// initialState should be an object that contains an array of notifications
const initialState: { newNotifications: Notification[] } = {
  newNotifications: [],
};

const notificationsSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    addNotification: (state, action: PayloadAction<Notification>) => {
      const newId =
        state.newNotifications.length > 0 ? (state.newNotifications[state.newNotifications.length - 1].id || 0) + 1 : 1;
      const newNotification = {
        ...action.payload,
        id: newId,
        isViewed: false, // Newly added notifications are not viewed
      };
      state.newNotifications.push(newNotification); // Correctly push only the new notification
    },

    removeNotification(state, action: PayloadAction<number>) {
      // Remove notification by id
      state.newNotifications = state.newNotifications.filter((notification: any) => notification.id !== action.payload);
    },
  },
});

// Export actions
export const { addNotification, removeNotification } = notificationsSlice.actions;

// Export reducer
export default notificationsSlice.reducer;
